export const otaConnectWizard = {
  google: {
    lead: "Nous vérifions d'abord que la fiche de votre logement est complète : Google n'a pas d'extranet et n'affiche que ce que nous lui envoyons.",
    goConnect: "Continuer sur Channex",
    nextIsChannex: "La dernière étape — choisir les chambres et tarifs que Google voit — se fait sur l'écran de Channex, qui va s'ouvrir.",
    typeLabel: "Quel type de logement est-ce ?",
    hotel: "Hôtel",
    hotelHint: "Avec plusieurs chambres",
    vr: "Location de vacances",
    vrHint: "Une maison ou un appartement entier",
    checking: "Vérification de la fiche…",
    ready: "Tout est prêt : Google peut le publier.",
    missing: "Il manque 1 chose avant de connecter | Il manque {count} choses avant de connecter",
    canFix: "Nous en avons déjà une partie et pouvons l'envoyer pour vous.",
    prepare: "Préparer la fiche",
    prepareFailed: "Impossible de préparer la fiche.",
    checkFailed: "Impossible de vérifier la fiche.",
    cancelLabel: "Politique d'annulation",
    cancelFree: "Annulation gratuite",
    cancelNon: "Non remboursable",
    bedrooms: "Chambres",
    beds: "Lits",
    bathrooms: "Salles de bain",
  },
  common: {
    close: "Fermer",
  },
  intro: {
    imageAlt: "Avant de connecter Booking, gardez ceci à l'esprit",
    continue: "J'ai compris, continuer",
  },
  header: {
    edit: "Modifier",
    connect: "Connecter",
    guidedStep: "Configuration guidée · étape {current} sur {total}",
  },
  steps: {
    connection: "Connexion",
    rooms: "Chambres",
    rates: "Tarifs",
    review: "Vérification",
    done: "Terminé",
  },
  fields: {
    hotel_id: { label: "ID de l'hôtel", hint: "Vous le trouverez dans l'extranet de votre OTA, en haut à droite." },
    hotel_code: { label: "Code de l'hôtel", hint: "L'identifiant de votre propriété sur l'OTA." },
    property_id: { label: "ID de la propriété", hint: "" },
    listing_id: { label: "ID de l'annonce", hint: "" },
    property_code: { label: "Code de la propriété", hint: "" },
    username: { label: "Nom d'utilisateur", hint: "Votre nom d'utilisateur de connexion à l'extranet de l'OTA." },
    user: { label: "Nom d'utilisateur", hint: "Votre nom d'utilisateur de connexion à l'extranet de l'OTA." },
    password: { label: "Mot de passe", hint: "Le mot de passe de votre extranet OTA." },
    api_key: { label: "Clé API", hint: "L'OTA vous la fournit." },
    agent_id: { label: "ID de l'agent", hint: "" },
  },
  step0: {
    lead: "Collez l'identifiant de votre propriété sur le canal. Nous le vérifierons instantanément.",
    loadingChannel: "Chargement des exigences du canal…",
    notAvailable: "Ce canal n'est pas encore disponible via l'API guidée.",
    oauthText: "{name} se connecte à votre compte via une connexion sécurisée. Lorsque vous cliquez, nous ouvrons {name} dans un autre onglet pour que vous puissiez autoriser l'accès ; à votre retour, la connexion apparaît dans vos canaux.",
    oauthConnect: "Se connecter avec {name}",
    oauthOpened: "Nous avons ouvert {name} dans un autre onglet. Autorisez l'accès depuis cet onglet et la connexion apparaîtra dans vos canaux.",
    currencyLabel: "Devise",
    currencyTooltip: "Le canal la définit pour votre propriété. Elle se remplit automatiquement lorsque vous vérifiez la connexion ; elle ne peut pas être modifiée.",
    currencyPlaceholder: "Se remplit lors de la vérification",
    currencyDetected: "Détectée automatiquement",
    currencyVerifyToDetect: "Vérifiez la connexion pour la détecter",
    verified: "Vérifié",
    testConnection: "Tester la connexion",
    testOk: "Connexion vérifiée. Continuez pour faire correspondre les chambres et les tarifs.",
    testFailedDefault: "Nous n'avons pas pu vérifier la connexion. Vérifiez l'identifiant.",
  },
  step1: {
    leadAirbnb: "Faites correspondre chaque annonce Airbnb à l'une de vos unités.",
    leadOther: "Faites correspondre chaque chambre {channel} à une unité de votre annonce.",
    listingChip: "Annonce : {name}",
    noLimitChip: "Aucune limite de comptes ou de propriétés",
    loadingRooms: "Chargement des chambres du canal…",
    noRooms: "Aucune chambre trouvée à mapper.",
    dupUnitWarning: "«{unit}» est attribuée à plusieurs chambres {channel}. Chaque chambre du canal doit correspondre à une chambre différente chez vous : si vous enregistrez ainsi, {channel} les vendrait toutes au même prix. Corrigez cela ci-dessous avant de continuer.",
    searchPlaceholder: "Rechercher…",
    noRoomMatch: "Aucune chambre ne correspond à «{query}».",
    copied: "Copié",
    copyId: "Copier l'ID : {id}",
    rateCountMeta: "{channel} · {count} tarif(s)",
    edit: "Modifier",
    disconnect: "Déconnecter",
    unitSearchPlaceholder: "Recherchez votre unité ou annonce…",
    noMatch: "Aucune correspondance",
    cancel: "Annuler",
  },
  step2: {
    lead: "Le tarif principal de chaque chambre se remplit automatiquement à partir de votre tarif {channel}. Si une chambre a plusieurs tarifs, définissez le pourcentage supplémentaire (ou inférieur) que vous facturerez sur chacun.",
    crossedFixed: "Un tarif a été associé à une autre chambre, ce qui ferait vendre {channel} au mauvais prix. Le tarif propre à chaque chambre a été restauré : vérifiez-les avant de continuer. | {count} tarifs ont été associés à une autre chambre, ce qui ferait vendre {channel} au mauvais prix. Le tarif propre à chaque chambre a été restauré : vérifiez-les avant de continuer.",
    noRates: "Aucun tarif trouvé à mapper.",
    yourPct: "Votre % pour cette chambre",
    auto: "Automatique",
    changePct: "Modifier le %",
    multiRateAlert: "Cette chambre a plusieurs tarifs. Définissez le pourcentage supplémentaire (ou inférieur) que vous facturerez à vos clients sur chacun s'ils réservent via {channel}.",
    minStayOnApply: "Il est enregistré en cliquant sur « Appliquer ».",
    minStayMissing: "Pas de séjour minimum propre : {channel} le vend avec le minimum du tarif principal",
    setMinStay: "Définir le séjour minimum",
    nights: "{n} nuit | {n} nuits",
    minNights: "min. {n} nuit | min. {n} nuits",
    minInherited: "min. du tarif principal",
    ownPlanSummary: "prix et minimum propres",
    minStayNotDerived: "Le séjour minimum de {nights} n'a pas été appliqué : « {rate} » est un tarif principal et utilise son propre séjour minimum. Pour que {channel} exige {nights} sur ce tarif, appliquez un % au lieu de le choisir.",
  },
  step3: {
    lead: "Voici ce que nous allons connecter sur {channel}. Vérifiez-le et cliquez sur Connecter.",
    channelCurrency: "Devise du canal :",
    chargesNote: "Le check-in/check-out et les frais (ménage, etc.) sont repris des paramètres de votre propriété.",
  },
  done: {
    titleConnected: "{name} connecté !",
    titleUpdated: "{name} mis à jour !",
    subActive: "Le canal est actif : nous synchronisons déjà les prix et la disponibilité.",
    subPaused: "Le canal est connecté mais en pause. Activez-le pour commencer à synchroniser les prix et la disponibilité.",
    subUpdated: "Le mappage du canal a été mis à jour avec succès.",
    notificationSent: "Notification envoyée",
    syncing: "Synchronisation…",
    paused: "En pause",
    activateTitle: "Activer le canal",
    activateDesc: "Commence à envoyer les prix et la disponibilité à {channel}.",
    activateBtn: "Activer le canal",
    activated: "Activé",
    loadReservationsTitle: "Importer les réservations à venir",
    loadReservationsDesc: "Importe dans WACheckin les réservations que vous avez déjà sur {channel}.",
    imported: "Importé",
    extract: "Importer",
  },
  rates: {
    mainRate: "Tarif principal",
    standardRate: "Tarif standard",
  },
  rooms: {
    listingFallback: "Annonce {id}",
    unitFallback: "unité",
  },
  buttons: {
    back: "Retour",
    saveChanges: "Enregistrer les modifications",
    connect: "Connecter",
    finish: "Terminer",
    continue: "Continuer",
  },
  errors: {
    dupUnit: "L'unité «{unit}» est attribuée à plusieurs chambres {channel}. Chaque chambre doit correspondre à une unité différente.",
    crossedBlocked: "Un tarif est associé à une autre chambre ({list}). Revenez à l'étape des tarifs et choisissez le tarif propre à chaque chambre : si vous enregistrez ainsi, {channel} vendrait au mauvais prix. | {count} tarifs sont associés à une autre chambre ({list}). Revenez à l'étape des tarifs et choisissez le tarif propre à chaque chambre : si vous enregistrez ainsi, {channel} vendrait au mauvais prix.",
    dupRate: "Le tarif «{rate}» est associé à plusieurs chambres {channel} ({rooms}). Chaque chambre doit avoir son propre tarif : si vous enregistrez ainsi, elles se vendraient au même prix.",
    roomJoiner: " et ",
    dupRateFallback: "un tarif",
    dupUnitFallback: "cette unité",
    needRate: "Faites correspondre au moins un tarif avant de connecter.",
    updateFailed: "Impossible de mettre à jour la connexion.",
    createFailed: "Impossible de créer la connexion.",
    unmapFailed: "Impossible de déconnecter l'annonce.",
    needAirbnbMap: "Faites correspondre au moins une annonce à une unité.",
    unitNoChannexRate: "L'unité \"{unit}\" n'a aucun tarif avec un identifiant Channex.",
    airbnbSaveFailed: "Impossible d'enregistrer les correspondances Airbnb.",
    actionFailed: "Impossible d'exécuter l'action.",
    oauthLinkFailed: "Impossible de générer le lien de connexion.",
    testFailed: "Erreur lors du test de la connexion.",
    testNoVerify: "Ce canal ne nécessite pas de vérification préalable.",
    rateCreateFailedNeedStandard: "Impossible de créer le tarif. Vérifiez que l'unité dispose d'un tarif standard.",
    rateCreateFailed: "Impossible de créer le tarif.",
    minStaySaveFailed: "« {rate} » a été choisi, mais son séjour minimum de {nights} n'a pas pu être enregistré : il garde celui qu'il avait.",
  },
};
